import { render } from "./paye_form.vue?vue&type=template&id=756254be&scoped=true"
import script from "./paye_form.vue?vue&type=script&lang=js"
export * from "./paye_form.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=756254be&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756254be"]])

export default __exports__